import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";

Vue.prototype.$omnichannel = new Vue({
  data() {
    return {
      ENDPOINTS: ENDPOINTS,
      add_config_omnichannel: false,
      omnichannel: [],
      loading_omnichannel: false,
      loading_button: false,
      loading_select: false,
      cadastro: {
        exp_pedido: 0,
        comissao_min: "",
        taxa_min_conveniencia: "",
        perc_min_comissao_web: "",
        perc_min_comissao_pos: "",
        perc_min_conveniencia_web: "",
        perc_min_conveniencia_pos: "",
        configsPlusAddEdit: "new",
        politicas_cookies: [],
        politica_privacidade: [],
        termo_compra: [],
        email_envio_oper: "",
        url_front_qrcode: "",
        error: {
          termo_compra: [],
          politicas_cookies: [],
          politica_privacidade: [],
          email_envio_oper: [],
          url_front_qrcode: [],
        },
      },
      politicas_cookies: {
        descricao_pt_BR: "",
        descricao_en_US: "",
        descricao_es_ES: "",
        texto_pt_BR: "",
        texto_en_US: "",
        texto_es_ES: "",
        tem_traducao: false,
      },
      termo_compra: {
        descricao_pt_BR: "",
        descricao_en_US: "",
        descricao_es_ES: "",
        texto_pt_BR: "",
        texto_en_US: "",
        texto_es_ES: "",
        tem_traducao: false,
      },
      politicaIdx: "",
      politica: {
        descricao_pt_BR: "",
        descricao_en_US: "",
        descricao_es_ES: "",
        texto_pt_BR: "",
        texto_en_US: "",
        texto_es_ES: "",
        tem_traducao: false,
      },
      politicaIdxPrivacy: "",
      termoIdx: "",
      indexValue: "",
      indexImageOrDoc: "",
      valueImageOrDoc: "",
      funcao: "",
      text: "",
      templates: {
        openModalTemplates: false,
        templateValue: null,
        templateID: null,
        templatesToSave: [],
        templateOptions: [],
      },
    };
  },
  methods: {
    /**
     * @description Método para listar as configurações do omnichannel
     * @returns {Promise} Retorna uma promise com o resultado da requisição
     */
    getConfigOmnichannel() {
      this.$axios
        .get(this.ENDPOINTS.LISTAR_CONFIG_OMNI)
        .then(response => {
          this.cadastro.politicas_cookies =
            response.politicas_cookies === null
              ? []
              : JSON.parse(response.politicas_cookies);
          this.cadastro.politica_privacidade =
            response.politicas === null ? [] : JSON.parse(response.politicas);
          this.cadastro.termo_compra =
            response.termo_compra === null
              ? []
              : JSON.parse(response.termo_compra);
          this.cadastro.email_envio_oper =
            response.email_envio_oper === null ? "" : response.email_envio_oper;
          this.cadastro.url_front_qrcode =
            response.url_front_qrcode === null ? "" : response.url_front_qrcode;
          this.cadastro.comissao_min =
            response.valor_min_comissao === null
              ? ""
              : response.valor_min_comissao;
          this.cadastro.taxa_min_conveniencia =
            response.taxa_min_conveniencia === null
              ? ""
              : response.taxa_min_conveniencia;
          this.cadastro.perc_min_conveniencia_web =
            response.perc_min_conveniencia_web === null
              ? ""
              : response.perc_min_conveniencia_web;
          this.cadastro.perc_min_conveniencia_pos =
            response.perc_min_conveniencia_pos === null
              ? ""
              : response.perc_min_conveniencia_pos;
          this.cadastro.perc_min_comissao_web =
            response.perc_min_comissao_web === null
              ? ""
              : response.perc_min_comissao_web;
          this.cadastro.perc_min_comissao_pos =
            response.perc_min_comissao_pos === null
              ? ""
              : response.perc_min_comissao_pos;
          this.cadastro.exp_pedido =
            response.exp_pedido === null ? 0 : response.exp_pedido;
          let parsedOdtTemplates = JSON.parse(response.ids_odt);
          this.templates.templatesToSave = Object.keys(parsedOdtTemplates).map(
            template => ({
              [template]: parsedOdtTemplates[template],
            })
          );
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    getValidODTTemplates() {
      this.$axios
        .get(this.ENDPOINTS.LISTAR_TEMPLATES_ODT)
        .then(response => {
          const arrayNamesToSave =
            this.$omnichannel.templates.templatesToSave.map(template => {
              return Object.keys(template)[0];
            });

          let responseValues = response.filter(template => {
            return !arrayNamesToSave.includes(template);
          });

          this.templates.templateOptions = responseValues.map(template => {
            return {
              value: template,
              text: template.split("_").join(" "),
              show: true,
            };
          });
        })
        .catch(error => {
          throw new Error(error);
        });
    },

    /**
     * @description Método para cadastrar ou alterar as configurações do omnichannel
     * @param {Object} dados - Dados da configuração omnichannel
     * @returns {Promise} Retorna uma promise com o resultado da requisição, fecha o modal e chama o método de listagem para atualizar a lista
     */
    async cadastrarConfigOmnichannel() {
      this.loading_button = true;
      let idODTObject = {};
      this.templates.templatesToSave.forEach(template => {
        idODTObject[Object.keys(template)[0]] = Object.values(template)[0];
      });

      let dados = {
        exp_pedido: parseInt(this.cadastro.exp_pedido),
        politicas_cookies: JSON.stringify(this.cadastro.politicas_cookies),
        politicas: JSON.stringify(this.cadastro.politica_privacidade),
        termo_compra: JSON.stringify(this.cadastro.termo_compra),
        email_envio_oper: this.cadastro.email_envio_oper,
        url_front_qrcode: this.cadastro.url_front_qrcode,
        valor_min_comissao: this.cadastro.comissao_min,
        taxa_min_conveniencia: this.cadastro.taxa_min_conveniencia,
        perc_min_comissao_web: this.cadastro.perc_min_comissao_web,
        perc_min_comissao_pos: this.cadastro.perc_min_comissao_pos,
        perc_min_conveniencia_web: this.cadastro.perc_min_conveniencia_web,
        perc_min_conveniencia_pos: this.cadastro.perc_min_conveniencia_pos,
        ids_odt: JSON.stringify(idODTObject),
      };
      await this.$axios
        .post(this.ENDPOINTS.ALTERAR_CONFIG_OMNI, dados)
        .then(() => {
          this.add_config_omnichannel = false;
          this.getConfigOmnichannel();
        })
        .catch(() => {
          this.loading_button = false;
        });
    },

    /**
     * @description Função que valida o cadastro
     */
    async validarCadastro() {
      if (this.cadastro.exp_pedido === "") {
        this.$config.alert(
          "Preencha o tempo de expiração do pedido!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.exp_pedido =
          "Preencha o tempo de expiração do pedido!";
        return;
      } else if (this.cadastro.exp_pedido <= 0) {
        this.$config.alert(
          "O tempo de expiração do pedido deve ser maior que 0!",
          this.$config.dados.errorColor
        );
        this.cadastro.error.exp_pedido =
          "O tempo de expiração do pedido deve ser maior que 0!";
        return;
      }

      /**
       * @description Bloco de validação para o campo e-mail de notificação
       */
      if (!this.$config.validarEmail(this.cadastro.email_envio_oper)) {
        this.$config.alert("E-mail inválido!", this.$config.dados.errorColor);
        this.cadastro.error.email_envio_oper = "E-mail inválido!";
        return;
      }

      /**
       * @description Bloco que chama a função para o cadastro/alteração.
       */
      this.cadastrarConfigOmnichannel();
    },

    /**
     * @description Função que abre modal para adicionar politicas de cookies
     */
    openModal(name, type, table, data, idx) {
      document.getElementsByClassName(name)[0].style.display = "flex";
      this.cadastro.configsPlusAddEdit = type;
      switch (table) {
        case "cookies":
          if (data) {
            this.politicas_cookies.descricao_pt_BR = data.titulo.substring(
              data.titulo.indexOf("<pt_BR>") + 7,
              data.titulo.indexOf("</pt_BR>")
            );
            this.politicas_cookies.descricao_en_US = data.titulo.substring(
              data.titulo.indexOf("<en_US>") + 7,
              data.titulo.indexOf("</en_US>")
            );
            this.politicas_cookies.descricao_es_ES = data.titulo.substring(
              data.titulo.indexOf("<es_ES>") + 7,
              data.titulo.indexOf("</es_ES>")
            );
            this.politicas_cookies.texto_pt_BR = data.valor.substring(
              data.valor.indexOf("<pt_BR>") + 7,
              data.valor.indexOf("</pt_BR>")
            );
            this.politicas_cookies.texto_en_US = data.valor.substring(
              data.valor.indexOf("<en_US>") + 7,
              data.valor.indexOf("</en_US>")
            );
            this.politicas_cookies.texto_es_ES = data.valor.substring(
              data.valor.indexOf("<es_ES>") + 7,
              data.valor.indexOf("</es_ES>")
            );

            this.politicas_cookies.tem_traducao = data.tem_traducao;
            this.politicaIdx = idx;
            return;
          }

          break;
        case "policy":
          if (data) {
            this.politica.descricao_pt_BR = data.titulo.substring(
              data.titulo.indexOf("<pt_BR>") + 7,
              data.titulo.indexOf("</pt_BR>")
            );
            this.politica.descricao_en_US = data.titulo.substring(
              data.titulo.indexOf("<en_US>") + 7,
              data.titulo.indexOf("</en_US>")
            );
            this.politica.descricao_es_ES = data.titulo.substring(
              data.titulo.indexOf("<es_ES>") + 7,
              data.titulo.indexOf("</es_ES>")
            );

            this.politica.texto_pt_BR = data.valor.substring(
              data.valor.indexOf("<pt_BR>") + 7,
              data.valor.indexOf("</pt_BR>")
            );
            this.politica.texto_en_US = data.valor.substring(
              data.valor.indexOf("<en_US>") + 7,
              data.valor.indexOf("</en_US>")
            );
            this.politica.texto_es_ES = data.valor.substring(
              data.valor.indexOf("<es_ES>") + 7,
              data.valor.indexOf("</es_ES>")
            );

            this.politica.tem_traducao = data.tem_traducao;
            this.politicaIdxPrivacy = idx;
          }
          break;
        default:
          break;
      }
    },

    /**
     * @description Função que abre modal para adicionar termo de compra
     */
    openModalTermo(name, type, data, idx) {
      document.getElementsByClassName(name)[0].style.display = "flex";
      this.cadastro.configsPlusAddEdit = type;

      if (data) {
        this.termo_compra.descricao_pt_BR = data.titulo.substring(
          data.titulo.indexOf("<pt_BR>") + 7,
          data.titulo.indexOf("</pt_BR>")
        );
        this.termo_compra.descricao_en_US = data.titulo.substring(
          data.titulo.indexOf("<en_US>") + 7,
          data.titulo.indexOf("</en_US>")
        );
        this.termo_compra.descricao_es_ES = data.titulo.substring(
          data.titulo.indexOf("<es_ES>") + 7,
          data.titulo.indexOf("</es_ES>")
        );
        this.termo_compra.texto_pt_BR = data.valor.substring(
          data.valor.indexOf("<pt_BR>") + 7,
          data.valor.indexOf("</pt_BR>")
        );
        this.termo_compra.texto_en_US = data.valor.substring(
          data.valor.indexOf("<en_US>") + 7,
          data.valor.indexOf("</en_US>")
        );
        this.termo_compra.texto_es_ES = data.valor.substring(
          data.valor.indexOf("<es_ES>") + 7,
          data.valor.indexOf("</es_ES>")
        );

        this.termo_compra.tem_traducao = data.tem_traducao;
        this.termoIdx = idx;
        return;
      }
    },

    openModalConfigTemplate(template) {
      this.$omnichannel.templates.openModalTemplates = true;
      const templateFilter = this.templates.templateOptions.find(
        templateValue => Object.keys(template)[0] === templateValue.value
      );
      if (templateFilter) {
        this.templates.templateOptions.map((item, index) => {
          if (templateFilter.value === item.value) {
            this.templates.templateOptions[index].show = true;
          }
        });
      }
      this.templates.templateValue = Object.keys(template)[0];
      this.templates.templateID = Object.values(template)[0];
    },

    /**
     * @description Função que abre modal para confirmar remoção das configurações do omnichannel
     */
    remover(index, type, name, msg) {
      this.text = msg;
      this.funcao = type;
      this.indexValue = index;
      this.indexImageOrDoc = index;
      this.valueImageOrDoc = name;
      this.$config.modalConfirm = true;
    },

    /**
     * @description Função que confirma as configurações do omnichannel
     */
    funcaoRemover(funcao) {
      switch (funcao) {
        case "cookies":
          this.cadastro.politicas_cookies.splice(this.indexValue, 1);
          break;
        case "policy":
          this.cadastro.politica_privacidade.splice(this.indexValue, 1);
          break;
        case "termo":
          this.cadastro.termo_compra.splice(this.indexValue, 1);
          break;
        case "template": {
          this.templates.templatesToSave.splice(this.indexValue, 1);
          const templateFilter = this.templates.templateOptions.find(
            templateValue => this.valueImageOrDoc === templateValue.value
          );
          if (templateFilter) {
            this.templates.templateOptions.map((item, index) => {
              if (templateFilter.value === item.value) {
                this.templates.templateOptions[index].show = true;
              }
            });
          }
          break;
        }
        default:
          break;
      }
    },

    limpaFormularioDeConfigOmnichannel() {
      this.cadastro.politicas_cookies = "";
      this.cadastro.politica_privacidade = "";
      this.cadastro.termo_compra = "";
      this.cadastro.exp_pedido = "";
      this.cadastro.email_envio_oper = "";
      this.cadastro.email_envio_oper = "";
      this.cadastro.comissao_min = "";
      this.cadastro.taxa_min_conveniencia = "";
      this.cadastro.perc_min_conveniencia_web = "";
      this.cadastro.perc_min_conveniencia_pos = "";
      this.cadastro.perc_min_comissao_web = "";
      this.cadastro.perc_min_comissao_pos = "";
    },

    limpaFormularioDeTemplates() {
      this.templates.templateValue = null;
      this.templates.templateID = null;
    },
  },
});
